import { VariableGroupStore } from './VariableGroupStore';
import { VesselReferenceStore } from './VesselReferenceStore';

export default {
    variableGroupStore: new VariableGroupStore(),
    vesselReferenceStore: new VesselReferenceStore()
};
